<!--
 * @Author: Lw
 * @Date: 2022-08-29 10:28:41
 * @LastEditors: Lw
 * @LastEditTime: 2022-09-02 15:55:59
-->
<script setup>
import { zhCN, dateZhCN } from 'naive-ui'
// import Layout from './components/Layout/index.vue'
import { useStore as useMobileStore } from '@/stores/mobile'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
const mobileStore = useMobileStore()

// 初始化语言设置
locale.value = localStorage.getItem('language') || 'zh'

function setOrientation() {
  if (window.orientation === 180 || window.orientation === 0) {
    // alert('竖屏')
    mobileStore.setMobileMode(true)
  }
  if (window.orientation === 90 || window.orientation === -90) {
    // alert('横屏')
    mobileStore.setMobileMode(false)
  }
}
window.addEventListener(
  'onorientationchange' in window ? 'orientationchange' : 'resize',
  setOrientation(),
  false
)
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition name="ease-out" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<style scoped>
body {
  margin: 0 !important;
}

.ease-out-enter-active,
.ease-out-leave-active {
  transition: opacity 0.15s ease-out;
}

.ease-out-enter-from,
.ease-out-leave-to {
  opacity: 0;
}
</style>
